import { jsx as a, jsxs as f } from "react/jsx-runtime";
import u from "react";
import { c as v, u as h } from "../chunks/useClickMotion.0a3ea4e5.js";
import { _ as x, a as y, b as k } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import n from "styled-components";
import { R as b, I as C } from "../chunks/index.cff5baaf.js";
const I = n.a.withConfig({
  displayName: "LinkIcon",
  componentId: "sc-m41lnt-0"
})(["", " color:var(--action-label-secondary-color);display:inline-flex;align-items:center;text-decoration:none;position:relative;z-index:0;height:var(--size-6x);width:fit-content;border-radius:var(--border-radius-sm);pointer-events:", ";opacity:", ";cursor:", ";&::after{content:'';position:absolute;z-index:-1;left:calc(-1 * var(--spacing-1x));right:calc(-1 * var(--spacing-1x));padding:0 var(--spacing-1x);margin:auto;width:100%;height:var(--size-5x);border-radius:var(--border-radius-sm);transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);}&:hover{&::after{", " transition-timing-function:var(--curve-productive-entrance);}}&:focus-visible{", " outline-offset:2px;}"], x, ({
  $isDisabled: i
}) => i ? "none" : "auto", ({
  $isDisabled: i
}) => i ? "var(--opacity-low)" : 1, ({
  $isDisabled: i
}) => i ? "not-allowed" : "pointer", y, k), w = n(b).withConfig({
  displayName: "Icon",
  componentId: "sc-m41lnt-1"
})(["padding-right:var(--spacing-half);color:var(--action-icon-secondary-color);"]), M = n.span.withConfig({
  displayName: "Container",
  componentId: "sc-m41lnt-2"
})(["display:flex;justify-content:center;align-items:center;position:relative;z-index:0;width:100%;"]), L = n.span.withConfig({
  displayName: "MotionLayer",
  componentId: "sc-m41lnt-3"
})(["position:absolute;z-index:-1;top:calc(-1 * var(--spacing-1x));left:calc(-1 * var(--spacing-1x));padding:var(--spacing-1x);width:100%;height:100%;"]), z = n.span.withConfig({
  displayName: "MotionLayerClick",
  componentId: "sc-m41lnt-4"
})(["", " width:calc(100% + var(--spacing-2x));height:calc(100% + var(--spacing-2x));display:inline-flex;position:relative;justify-content:center;align-items:center;margin:calc(-1 * var(--spacing-1x));border-radius:var(--default-border-radius);"], (i) => i.$isClickMotion && v()), N = u.forwardRef(({
  children: i,
  ariaLabel: s,
  icon: t,
  onClick: e,
  href: r,
  disabled: l = !1,
  ...d
}, p) => {
  const {
    isClickMotion: g,
    startClickMotion: m
  } = h(), o = l || !r;
  return /* @__PURE__ */ a(I, { "aria-label": s, ref: p, onClick: (c) => {
    if (o) {
      c.preventDefault();
      return;
    }
    e && e(c), m();
  }, "data-testid": "rango-link-icon", "data-rango-component": "rango-link-icon", "data-is-rango": "true", href: o ? void 0 : r, $isDisabled: o, tabIndex: o ? -1 : 0, ...d, children: /* @__PURE__ */ f(M, { children: [
    /* @__PURE__ */ a(L, { children: /* @__PURE__ */ a(z, { $isClickMotion: g }) }),
    /* @__PURE__ */ a(w, { icon: t || "LinkLine", size: C.MD }),
    i
  ] }) });
});
N.displayName = "RangoLinkIcon";
export {
  N as RangoLinkIcon
};
